import { useEffect } from "react";
import acao from '../../images/acao.jpg'
import AOS from 'aos';
import 'aos/dist/aos.css';
function FirstComponent() {
    useEffect(() => {
            AOS.init();
        }, [])
    return (
        <div className="w-full bg-cover bg-center h-home flex lg:flex-row flex-col lg:justify-evenly justify-center " style={{ backgroundImage: `url(${acao})` }}>
            <div className="p-5 flex items-start justify-center flex-col flex">
                <h3 data-aos="fade-right" data-aos-duration="1500" className=' text-white text-center text-4xl font-bold font-rubik lg:text-7xl md:text-5xl'>A Associação Keralty <br /> agora tem chave pix.</h3>
                <h3 data-aos="fade-right" data-aos-duration="2500" className='text-white text-center font-rubik lg:text-2xl md:text-[20px] mt-10'>Doe a qualquer momento pelo pix:
                    <p data-aos="fade-right" data-aos-duration="2500" className='text-white font-rubik lg:text-2xl md:text-[20px] bg-blue-700 mt-10'>9xxxxxxx/xxxx-xxx</p>
                </h3>
            </div>
        </div>
    )
}

export default FirstComponent
